var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vue-drag-select", on: { mousedown: _vm.onMouseDown } },
    [
      _vm._t("default", null, { selectedItems: _vm.selectedItems }),
      _vm._v(" "),
      _vm.mouseDown
        ? _c("div", {
            staticClass: "vue-drag-select-box",
            style: _vm.selectionBoxStyling,
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }